export const governmentAllocationSummaryCurrencyTableColumns = [
  { label: '', value: 'actions' },
  { label: 'Serviço', value: 'category_display_name' },
  { label: 'Total Empenhado', value: 'allocated_total' },
  { label: 'Total Distribuído', value: 'distributed_total' },
  { label: 'Total Disponível (Distribuir)', value: 'available_total' },
  { label: 'Total Consumido', value: 'consumed_total' },
  { label: 'Total Disponível (Consumir)', value: 'remaining_distribution_total' },
]

export const governmentAllocationSummaryQuantityTableColumns = [
  { label: '', value: 'actions' },
  { label: 'Serviço', value: 'category_display_name' },
  { label: 'Total Empenhado', value: 'allocated_quantity' },
  { label: 'Total Distribuído', value: 'distributed_quantity' },
  { label: 'Total Disponível (Distribuir)', value: 'available_quantity' },
  { label: 'Total Consumido', value: 'consumed_quantity' },
  { label: 'Total Disponível (Consumir)', value: 'remaining_distribution_quantity' },
]
